import React from 'react'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { Card, Chip, Divider, Paper } from '@mui/material'
import EventIcon from '@mui/icons-material/Event'
import UpcomingEvents from './UpcomingEvents'
import OutstandingInvoices from './OutstandingInvoices'
import Documents from './Documents'

const Dashboard = () => {
  return (
    <Grid container spacing={5}>
      <UpcomingEvents />
      <OutstandingInvoices />
      <Documents />
    </Grid>
  )
}

export default Dashboard
